export enum ToastMessageSeverity {
  success = 0,
  info,
  warn,
  error,
  contrast,
  secondary,
}
